import PlusIcon from "@assets/images/plus-teal.svg";
import TrashCan from "@assets/images/trash.svg";
import { Button } from "@material-ui/core";
import MyTypography from "@saleor/components/MyTypography";
import useAppState from "@saleor/hooks/useAppState";
import React from "react";
import SVG from "react-inlinesvg";
import { FormattedMessage } from "react-intl";

import useStyles from "./styles";

interface BottomBarProps {
  selectedLine: number;
  disabled: boolean;
  onClick: () => void;
  onSubmit: () => void;
  onDeleteClick: () => void;
}

const BottomBar: React.FC<BottomBarProps> = ({
  selectedLine,
  disabled,
  onClick,
  onSubmit,
  onDeleteClick
}) => {
  const [appState, _] = useAppState();
  const { expandMenu, bodyPaddingRight } = appState;
  const classes = useStyles({ expandMenu, bodyPaddingRight });
  return (
    <div className={classes.bottomBar}>
      <div>
        <Button
          id="deleteItemButton"
          variant={"outlined"}
          color={"primary"}
          onClick={onDeleteClick}
          className={classes.btnDelete}
          disabled={selectedLine === 0 ? true : false}
        >
          <SVG src={TrashCan} className={classes.colorIconTrash} />
          <MyTypography component="span" variant="body2" color="inherit">
            <FormattedMessage defaultMessage={"ลบรายการที่เลือก"} /> (
            <b>{selectedLine}</b>)
          </MyTypography>
        </Button>

        <Button
          id="addItemButton"
          variant={"outlined"}
          color={"secondary"}
          onClick={onClick}
          startIcon={<img src={PlusIcon} alt="plus-icon" />}
        >
          <MyTypography component="span" variant="button2" color="inherit">
            <FormattedMessage defaultMessage={"เพิ่มรายการสินค้า"} />
          </MyTypography>
        </Button>
      </div>
      <div className={classes.barRight}>
        <MyTypography variant="body2">
          เลือก{" "}
          <MyTypography component="span" variant="subtitle2">
            {selectedLine}
          </MyTypography>{" "}
          รายการ
        </MyTypography>
        <div className={classes.btnOrder}>
          <Button
            id="continueButton"
            variant={"contained"}
            color={"secondary"}
            disabled={disabled}
            onClick={onSubmit}
          >
            <MyTypography component="span" variant="subtitle1" color="inherit">
              <FormattedMessage defaultMessage={"ดำเนินการต่อ"} />
            </MyTypography>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BottomBar;
